import { GridColDef } from '@mui/x-data-grid';
import { Attachment } from '../../../../../../shared/types/shared';
import { fileToBase64 } from '../../../../../../shared/utils/files';
import { LegalProceedingsAttachmentProps } from './props';
import { TableTooltip } from '../../../../../components/general/table';
import { DateTooltip } from '../../../../../components/general/dateTooltip';
import {
    LegalProceedingsAttachmentActions,
    LegalProceedingsAttachmentActionsLast,
} from './actions';

export const useLegalProceedingsAttachment = ({
    data,
    onChangeData,
}: LegalProceedingsAttachmentProps) => {
    const handleOnChange = async (files: File[]) => {
        const data: Attachment[] = [];
        for await (const file of files) {
            const res = await fileToBase64(file);
            if (res) data.push(res);
        }
        if (onChangeData) onChangeData(data);
    };

    const columns: GridColDef<Attachment>[] = [
        {
            field: 'actions',
            headerName: 'Acciones',
            width: 100,
            sortable: false,
            disableColumnMenu: true,
            filterable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row) => (
                <LegalProceedingsAttachmentActions attachment={row.row} />
            ),
        },
        {
            field: 'name',
            headerName: 'Nombre',
            minWidth: 150,
            flex: 0.6,
            renderCell: (row) => <TableTooltip value={row.row.name || ''} />,
        },
        {
            field: 'createdBy',
            headerName: 'Creado por',
            minWidth: 150,
            flex: 0.6,
            renderCell: (row) => (
                <TableTooltip
                    value={
                        row.row.createdBy
                            ? `(${row.row.createdBy.username}) ${row.row.createdBy.name} ${row.row.createdBy.surname}`
                            : ''
                    }
                />
            ),
        },
        {
            field: 'created_at',
            headerName: 'Fecha de creación',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <DateTooltip date={row.row.created_at} showFornow />
            ),
        },
        {
            field: 'link',
            headerName: 'Web link adjunto',
            width: 100,
            sortable: false,
            disableColumnMenu: true,
            filterable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row) => (
                <LegalProceedingsAttachmentActionsLast attachment={row.row} />
            ),
        },
    ];

    return {
        handleOnChange,
        data,
        columns,
    };
};
